import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { API_BASE_URL } from '../config/api.config';
import { AccessTokenService } from '../services/access-token.service';

export const accessTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const url = new URL(request.url, API_BASE_URL);
  const gateway = new URL(API_BASE_URL);
  const isGateway = url.origin === gateway.origin &&
    (url.pathname === gateway.pathname || url.pathname.startsWith(`${gateway.pathname}/`));
  const isPublicSessionEndpoint =
    url.pathname === `${gateway.pathname}/auth/refresh` ||
    url.pathname === `${gateway.pathname}/admin/impersonations/exchange`;
  if (!isGateway || isPublicSessionEndpoint) return next(request);

  const token = inject(AccessTokenService).getToken();
  return next(token ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : request);
};
